/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as ResetPasswordRouteImport } from './routes/resetPassword'
import { Route as ForgotPasswordRouteImport } from './routes/forgotPassword'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StaffSigninRouteImport } from './routes/staff_.signin'
import { Route as StaffForgotPasswordRouteImport } from './routes/staff_.forgotPassword'
import { Route as AuthStaffRouteRouteImport } from './routes/_auth/staff/route'
import { Route as AuthOrgsRouteRouteImport } from './routes/_auth/orgs/route'
import { Route as AuthSettingsIndexRouteImport } from './routes/_auth/settings/index'
import { Route as AuthOrgsIndexRouteImport } from './routes/_auth/orgs/index'
import { Route as AuthOIndexRouteImport } from './routes/_auth/o/index'
import { Route as LobbyProjectIdTokenRouteImport } from './routes/lobby/$projectId.$token'
import { Route as AuthStaffSessionsRouteImport } from './routes/_auth/staff/sessions'
import { Route as AuthStaffEnginesRouteImport } from './routes/_auth/staff/engines'
import { Route as AuthStaffURouteRouteImport } from './routes/_auth/staff/u/route'
import { Route as AuthStaffORouteRouteImport } from './routes/_auth/staff/o/route'
import { Route as AuthOrgsOrgIdRouteRouteImport } from './routes/_auth/orgs/$orgId/route'
import { Route as AuthOOrgIdRouteRouteImport } from './routes/_auth/o/$orgId/route'
import { Route as AuthStaffUIndexRouteImport } from './routes/_auth/staff/u/index'
import { Route as AuthStaffOIndexRouteImport } from './routes/_auth/staff/o/index'
import { Route as AuthOOrgIdIndexRouteImport } from './routes/_auth/o/$orgId/index'
import { Route as AuthStaffUUserIdRouteImport } from './routes/_auth/staff/u/$userId'
import { Route as AuthOrgsOrgIdMembersRouteImport } from './routes/_auth/orgs/$orgId/members'
import { Route as AuthOrgsOrgIdApiKeysRouteRouteImport } from './routes/_auth/orgs/$orgId/apiKeys/route'
import { Route as AuthOOrgIdSessionsRouteRouteImport } from './routes/_auth/o/$orgId/sessions/route'
import { Route as AuthOOrgIdProjectsRouteRouteImport } from './routes/_auth/o/$orgId/projects/route'
import { Route as AuthOOrgIdMultiviewRouteRouteImport } from './routes/_auth/o/$orgId/multiview/route'
import { Route as AuthOOrgIdMediaLibraryRouteRouteImport } from './routes/_auth/o/$orgId/mediaLibrary/route'
import { Route as AuthOOrgIdLiveOutputsRouteRouteImport } from './routes/_auth/o/$orgId/liveOutputs/route'
import { Route as AuthOOrgIdLiveInputsRouteRouteImport } from './routes/_auth/o/$orgId/liveInputs/route'
import { Route as AuthOOrgIdEncodingPresetsRouteRouteImport } from './routes/_auth/o/$orgId/encodingPresets/route'
import { Route as AuthOOrgIdCommentaryBoxRouteRouteImport } from './routes/_auth/o/$orgId/commentaryBox/route'
import { Route as AuthOOrgIdAutomationsRouteRouteImport } from './routes/_auth/o/$orgId/automations/route'
import { Route as AuthOrgsOrgIdApiKeysIndexRouteImport } from './routes/_auth/orgs/$orgId/apiKeys/index'
import { Route as AuthOOrgIdSessionsIndexRouteImport } from './routes/_auth/o/$orgId/sessions/index'
import { Route as AuthOOrgIdProjectsIndexRouteImport } from './routes/_auth/o/$orgId/projects/index'
import { Route as AuthOOrgIdMultiviewIndexRouteImport } from './routes/_auth/o/$orgId/multiview/index'
import { Route as AuthOOrgIdMediaLibraryIndexRouteImport } from './routes/_auth/o/$orgId/mediaLibrary/index'
import { Route as AuthOOrgIdLiveOutputsIndexRouteImport } from './routes/_auth/o/$orgId/liveOutputs/index'
import { Route as AuthOOrgIdLiveInputsIndexRouteImport } from './routes/_auth/o/$orgId/liveInputs/index'
import { Route as AuthOOrgIdEncodingPresetsIndexRouteImport } from './routes/_auth/o/$orgId/encodingPresets/index'
import { Route as AuthOOrgIdCommentaryBoxIndexRouteImport } from './routes/_auth/o/$orgId/commentaryBox/index'
import { Route as AuthOOrgIdAutomationsIndexRouteImport } from './routes/_auth/o/$orgId/automations/index'
import { Route as AuthStaffOOrgIdMembersRouteImport } from './routes/_auth/staff/o/$orgId/members'
import { Route as AuthStaffOOrgIdFeaturesRouteImport } from './routes/_auth/staff/o/$orgId/features'
import { Route as AuthOrgsOrgIdApiKeysNameRouteImport } from './routes/_auth/orgs/$orgId/apiKeys/$name'
import { Route as AuthOOrgIdUsageSessionsRouteImport } from './routes/_auth/o/$orgId/usage/sessions'
import { Route as AuthOOrgIdUsageOverviewRouteImport } from './routes/_auth/o/$orgId/usage/overview'
import { Route as AuthOOrgIdUsageDistributionsRouteImport } from './routes/_auth/o/$orgId/usage/distributions'
import { Route as AuthOOrgIdLiveOutputsLiveOutputIdRouteImport } from './routes/_auth/o/$orgId/liveOutputs/$liveOutputId'
import { Route as AuthOOrgIdLiveInputsLiveInputIdRouteImport } from './routes/_auth/o/$orgId/liveInputs/$liveInputId'
import { Route as AuthOOrgIdEncodingPresetsNewRouteImport } from './routes/_auth/o/$orgId/encodingPresets/new'
import { Route as AuthOOrgIdEncodingPresetsEncodingPresetIdRouteImport } from './routes/_auth/o/$orgId/encodingPresets/$encodingPresetId'
import { Route as AuthOOrgIdCommentaryBoxCommentaryBoxIdRouteImport } from './routes/_auth/o/$orgId/commentaryBox/$commentaryBoxId'
import { Route as AuthOOrgIdAutomationsScheduledRouteImport } from './routes/_auth/o/$orgId/automations/scheduled'
import { Route as AuthOOrgIdAutomationsDataEventsRouteImport } from './routes/_auth/o/$orgId/automations/dataEvents'
import { Route as AuthOOrgIdProjectsProjectIdSRouteRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/s/route'
import { Route as AuthOOrgIdProjectsProjectIdManageRouteRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/manage/route'
import { Route as AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/$workflowSessionId/route'
import { Route as AuthOOrgIdProjectsProjectIdWorkflowIndexRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/workflow/index'
import { Route as AuthOOrgIdProjectsProjectIdSIndexRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/s/index'
import { Route as AuthOOrgIdProjectsProjectIdManageIndexRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/manage/index'
import { Route as AuthOOrgIdProjectsProjectIdManageComponentsRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/manage/components'
import { Route as AuthOOrgIdProjectsProjectIdWorkflowSessionIdWorkflowRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/$workflowSessionId/workflow'
import { Route as AuthOOrgIdProjectsProjectIdWorkflowSessionIdMonitorRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/$workflowSessionId/monitor'
import { Route as AuthOOrgIdProjectsProjectIdWorkflowSessionIdControlRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/$workflowSessionId/control'
import { Route as AuthOOrgIdProjectsProjectIdSWorkflowSessionIdIndexRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/index'
import { Route as AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/route'
import { Route as AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRIndexRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/index'
import { Route as AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRecordingIdRouteImport } from './routes/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId'

const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/resetPassword',
  path: '/resetPassword',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgotPassword',
  path: '/forgotPassword',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffSigninRoute = StaffSigninRouteImport.update({
  id: '/staff_/signin',
  path: '/staff/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffForgotPasswordRoute = StaffForgotPasswordRouteImport.update({
  id: '/staff_/forgotPassword',
  path: '/staff/forgotPassword',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthStaffRouteRoute = AuthStaffRouteRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOrgsRouteRoute = AuthOrgsRouteRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSettingsIndexRoute = AuthSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOrgsIndexRoute = AuthOrgsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOrgsRouteRoute,
} as any)
const AuthOIndexRoute = AuthOIndexRouteImport.update({
  id: '/o/',
  path: '/o/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const LobbyProjectIdTokenRoute = LobbyProjectIdTokenRouteImport.update({
  id: '/lobby/$projectId/$token',
  path: '/lobby/$projectId/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthStaffSessionsRoute = AuthStaffSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AuthStaffRouteRoute,
} as any)
const AuthStaffEnginesRoute = AuthStaffEnginesRouteImport.update({
  id: '/engines',
  path: '/engines',
  getParentRoute: () => AuthStaffRouteRoute,
} as any)
const AuthStaffURouteRoute = AuthStaffURouteRouteImport.update({
  id: '/u',
  path: '/u',
  getParentRoute: () => AuthStaffRouteRoute,
} as any)
const AuthStaffORouteRoute = AuthStaffORouteRouteImport.update({
  id: '/o',
  path: '/o',
  getParentRoute: () => AuthStaffRouteRoute,
} as any)
const AuthOrgsOrgIdRouteRoute = AuthOrgsOrgIdRouteRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => AuthOrgsRouteRoute,
} as any)
const AuthOOrgIdRouteRoute = AuthOOrgIdRouteRouteImport.update({
  id: '/o/$orgId',
  path: '/o/$orgId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthStaffUIndexRoute = AuthStaffUIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthStaffURouteRoute,
} as any)
const AuthStaffOIndexRoute = AuthStaffOIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthStaffORouteRoute,
} as any)
const AuthOOrgIdIndexRoute = AuthOOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOOrgIdRouteRoute,
} as any)
const AuthStaffUUserIdRoute = AuthStaffUUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AuthStaffURouteRoute,
} as any)
const AuthOrgsOrgIdMembersRoute = AuthOrgsOrgIdMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AuthOrgsOrgIdRouteRoute,
} as any)
const AuthOrgsOrgIdApiKeysRouteRoute =
  AuthOrgsOrgIdApiKeysRouteRouteImport.update({
    id: '/apiKeys',
    path: '/apiKeys',
    getParentRoute: () => AuthOrgsOrgIdRouteRoute,
  } as any)
const AuthOOrgIdSessionsRouteRoute = AuthOOrgIdSessionsRouteRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AuthOOrgIdRouteRoute,
} as any)
const AuthOOrgIdProjectsRouteRoute = AuthOOrgIdProjectsRouteRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AuthOOrgIdRouteRoute,
} as any)
const AuthOOrgIdMultiviewRouteRoute =
  AuthOOrgIdMultiviewRouteRouteImport.update({
    id: '/multiview',
    path: '/multiview',
    getParentRoute: () => AuthOOrgIdRouteRoute,
  } as any)
const AuthOOrgIdMediaLibraryRouteRoute =
  AuthOOrgIdMediaLibraryRouteRouteImport.update({
    id: '/mediaLibrary',
    path: '/mediaLibrary',
    getParentRoute: () => AuthOOrgIdRouteRoute,
  } as any)
const AuthOOrgIdLiveOutputsRouteRoute =
  AuthOOrgIdLiveOutputsRouteRouteImport.update({
    id: '/liveOutputs',
    path: '/liveOutputs',
    getParentRoute: () => AuthOOrgIdRouteRoute,
  } as any)
const AuthOOrgIdLiveInputsRouteRoute =
  AuthOOrgIdLiveInputsRouteRouteImport.update({
    id: '/liveInputs',
    path: '/liveInputs',
    getParentRoute: () => AuthOOrgIdRouteRoute,
  } as any)
const AuthOOrgIdEncodingPresetsRouteRoute =
  AuthOOrgIdEncodingPresetsRouteRouteImport.update({
    id: '/encodingPresets',
    path: '/encodingPresets',
    getParentRoute: () => AuthOOrgIdRouteRoute,
  } as any)
const AuthOOrgIdCommentaryBoxRouteRoute =
  AuthOOrgIdCommentaryBoxRouteRouteImport.update({
    id: '/commentaryBox',
    path: '/commentaryBox',
    getParentRoute: () => AuthOOrgIdRouteRoute,
  } as any)
const AuthOOrgIdAutomationsRouteRoute =
  AuthOOrgIdAutomationsRouteRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => AuthOOrgIdRouteRoute,
  } as any)
const AuthOrgsOrgIdApiKeysIndexRoute =
  AuthOrgsOrgIdApiKeysIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgsOrgIdApiKeysRouteRoute,
  } as any)
const AuthOOrgIdSessionsIndexRoute = AuthOOrgIdSessionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOOrgIdSessionsRouteRoute,
} as any)
const AuthOOrgIdProjectsIndexRoute = AuthOOrgIdProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOOrgIdProjectsRouteRoute,
} as any)
const AuthOOrgIdMultiviewIndexRoute =
  AuthOOrgIdMultiviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOOrgIdMultiviewRouteRoute,
  } as any)
const AuthOOrgIdMediaLibraryIndexRoute =
  AuthOOrgIdMediaLibraryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOOrgIdMediaLibraryRouteRoute,
  } as any)
const AuthOOrgIdLiveOutputsIndexRoute =
  AuthOOrgIdLiveOutputsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOOrgIdLiveOutputsRouteRoute,
  } as any)
const AuthOOrgIdLiveInputsIndexRoute =
  AuthOOrgIdLiveInputsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOOrgIdLiveInputsRouteRoute,
  } as any)
const AuthOOrgIdEncodingPresetsIndexRoute =
  AuthOOrgIdEncodingPresetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOOrgIdEncodingPresetsRouteRoute,
  } as any)
const AuthOOrgIdCommentaryBoxIndexRoute =
  AuthOOrgIdCommentaryBoxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOOrgIdCommentaryBoxRouteRoute,
  } as any)
const AuthOOrgIdAutomationsIndexRoute =
  AuthOOrgIdAutomationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOOrgIdAutomationsRouteRoute,
  } as any)
const AuthStaffOOrgIdMembersRoute = AuthStaffOOrgIdMembersRouteImport.update({
  id: '/$orgId/members',
  path: '/$orgId/members',
  getParentRoute: () => AuthStaffORouteRoute,
} as any)
const AuthStaffOOrgIdFeaturesRoute = AuthStaffOOrgIdFeaturesRouteImport.update({
  id: '/$orgId/features',
  path: '/$orgId/features',
  getParentRoute: () => AuthStaffORouteRoute,
} as any)
const AuthOrgsOrgIdApiKeysNameRoute =
  AuthOrgsOrgIdApiKeysNameRouteImport.update({
    id: '/$name',
    path: '/$name',
    getParentRoute: () => AuthOrgsOrgIdApiKeysRouteRoute,
  } as any)
const AuthOOrgIdUsageSessionsRoute = AuthOOrgIdUsageSessionsRouteImport.update({
  id: '/usage/sessions',
  path: '/usage/sessions',
  getParentRoute: () => AuthOOrgIdRouteRoute,
} as any)
const AuthOOrgIdUsageOverviewRoute = AuthOOrgIdUsageOverviewRouteImport.update({
  id: '/usage/overview',
  path: '/usage/overview',
  getParentRoute: () => AuthOOrgIdRouteRoute,
} as any)
const AuthOOrgIdUsageDistributionsRoute =
  AuthOOrgIdUsageDistributionsRouteImport.update({
    id: '/usage/distributions',
    path: '/usage/distributions',
    getParentRoute: () => AuthOOrgIdRouteRoute,
  } as any)
const AuthOOrgIdLiveOutputsLiveOutputIdRoute =
  AuthOOrgIdLiveOutputsLiveOutputIdRouteImport.update({
    id: '/$liveOutputId',
    path: '/$liveOutputId',
    getParentRoute: () => AuthOOrgIdLiveOutputsRouteRoute,
  } as any)
const AuthOOrgIdLiveInputsLiveInputIdRoute =
  AuthOOrgIdLiveInputsLiveInputIdRouteImport.update({
    id: '/$liveInputId',
    path: '/$liveInputId',
    getParentRoute: () => AuthOOrgIdLiveInputsRouteRoute,
  } as any)
const AuthOOrgIdEncodingPresetsNewRoute =
  AuthOOrgIdEncodingPresetsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthOOrgIdEncodingPresetsRouteRoute,
  } as any)
const AuthOOrgIdEncodingPresetsEncodingPresetIdRoute =
  AuthOOrgIdEncodingPresetsEncodingPresetIdRouteImport.update({
    id: '/$encodingPresetId',
    path: '/$encodingPresetId',
    getParentRoute: () => AuthOOrgIdEncodingPresetsRouteRoute,
  } as any)
const AuthOOrgIdCommentaryBoxCommentaryBoxIdRoute =
  AuthOOrgIdCommentaryBoxCommentaryBoxIdRouteImport.update({
    id: '/$commentaryBoxId',
    path: '/$commentaryBoxId',
    getParentRoute: () => AuthOOrgIdCommentaryBoxRouteRoute,
  } as any)
const AuthOOrgIdAutomationsScheduledRoute =
  AuthOOrgIdAutomationsScheduledRouteImport.update({
    id: '/scheduled',
    path: '/scheduled',
    getParentRoute: () => AuthOOrgIdAutomationsRouteRoute,
  } as any)
const AuthOOrgIdAutomationsDataEventsRoute =
  AuthOOrgIdAutomationsDataEventsRouteImport.update({
    id: '/dataEvents',
    path: '/dataEvents',
    getParentRoute: () => AuthOOrgIdAutomationsRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdSRouteRoute =
  AuthOOrgIdProjectsProjectIdSRouteRouteImport.update({
    id: '/$projectId/s',
    path: '/$projectId/s',
    getParentRoute: () => AuthOOrgIdProjectsRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdManageRouteRoute =
  AuthOOrgIdProjectsProjectIdManageRouteRouteImport.update({
    id: '/$projectId/manage',
    path: '/$projectId/manage',
    getParentRoute: () => AuthOOrgIdProjectsRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRoute =
  AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteImport.update({
    id: '/$projectId/$workflowSessionId',
    path: '/$projectId/$workflowSessionId',
    getParentRoute: () => AuthOOrgIdProjectsRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdWorkflowIndexRoute =
  AuthOOrgIdProjectsProjectIdWorkflowIndexRouteImport.update({
    id: '/$projectId/workflow/',
    path: '/$projectId/workflow/',
    getParentRoute: () => AuthOOrgIdProjectsRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdSIndexRoute =
  AuthOOrgIdProjectsProjectIdSIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOOrgIdProjectsProjectIdSRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdManageIndexRoute =
  AuthOOrgIdProjectsProjectIdManageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOOrgIdProjectsProjectIdManageRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdManageComponentsRoute =
  AuthOOrgIdProjectsProjectIdManageComponentsRouteImport.update({
    id: '/components',
    path: '/components',
    getParentRoute: () => AuthOOrgIdProjectsProjectIdManageRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdWorkflowSessionIdWorkflowRoute =
  AuthOOrgIdProjectsProjectIdWorkflowSessionIdWorkflowRouteImport.update({
    id: '/workflow',
    path: '/workflow',
    getParentRoute: () =>
      AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdWorkflowSessionIdMonitorRoute =
  AuthOOrgIdProjectsProjectIdWorkflowSessionIdMonitorRouteImport.update({
    id: '/monitor',
    path: '/monitor',
    getParentRoute: () =>
      AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdWorkflowSessionIdControlRoute =
  AuthOOrgIdProjectsProjectIdWorkflowSessionIdControlRouteImport.update({
    id: '/control',
    path: '/control',
    getParentRoute: () =>
      AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdSWorkflowSessionIdIndexRoute =
  AuthOOrgIdProjectsProjectIdSWorkflowSessionIdIndexRouteImport.update({
    id: '/$workflowSessionId/',
    path: '/$workflowSessionId/',
    getParentRoute: () => AuthOOrgIdProjectsProjectIdSRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRoute =
  AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRouteImport.update({
    id: '/$workflowSessionId/r',
    path: '/$workflowSessionId/r',
    getParentRoute: () => AuthOOrgIdProjectsProjectIdSRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRIndexRoute =
  AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRecordingIdRoute =
  AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRecordingIdRouteImport.update({
    id: '/$recordingId',
    path: '/$recordingId',
    getParentRoute: () =>
      AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgotPassword': typeof ForgotPasswordRoute
  '/resetPassword': typeof ResetPasswordRoute
  '/signin': typeof SigninRoute
  '/orgs': typeof AuthOrgsRouteRouteWithChildren
  '/staff': typeof AuthStaffRouteRouteWithChildren
  '/staff/forgotPassword': typeof StaffForgotPasswordRoute
  '/staff/signin': typeof StaffSigninRoute
  '/o/$orgId': typeof AuthOOrgIdRouteRouteWithChildren
  '/orgs/$orgId': typeof AuthOrgsOrgIdRouteRouteWithChildren
  '/staff/o': typeof AuthStaffORouteRouteWithChildren
  '/staff/u': typeof AuthStaffURouteRouteWithChildren
  '/staff/engines': typeof AuthStaffEnginesRoute
  '/staff/sessions': typeof AuthStaffSessionsRoute
  '/lobby/$projectId/$token': typeof LobbyProjectIdTokenRoute
  '/o': typeof AuthOIndexRoute
  '/orgs/': typeof AuthOrgsIndexRoute
  '/settings': typeof AuthSettingsIndexRoute
  '/o/$orgId/automations': typeof AuthOOrgIdAutomationsRouteRouteWithChildren
  '/o/$orgId/commentaryBox': typeof AuthOOrgIdCommentaryBoxRouteRouteWithChildren
  '/o/$orgId/encodingPresets': typeof AuthOOrgIdEncodingPresetsRouteRouteWithChildren
  '/o/$orgId/liveInputs': typeof AuthOOrgIdLiveInputsRouteRouteWithChildren
  '/o/$orgId/liveOutputs': typeof AuthOOrgIdLiveOutputsRouteRouteWithChildren
  '/o/$orgId/mediaLibrary': typeof AuthOOrgIdMediaLibraryRouteRouteWithChildren
  '/o/$orgId/multiview': typeof AuthOOrgIdMultiviewRouteRouteWithChildren
  '/o/$orgId/projects': typeof AuthOOrgIdProjectsRouteRouteWithChildren
  '/o/$orgId/sessions': typeof AuthOOrgIdSessionsRouteRouteWithChildren
  '/orgs/$orgId/apiKeys': typeof AuthOrgsOrgIdApiKeysRouteRouteWithChildren
  '/orgs/$orgId/members': typeof AuthOrgsOrgIdMembersRoute
  '/staff/u/$userId': typeof AuthStaffUUserIdRoute
  '/o/$orgId/': typeof AuthOOrgIdIndexRoute
  '/staff/o/': typeof AuthStaffOIndexRoute
  '/staff/u/': typeof AuthStaffUIndexRoute
  '/o/$orgId/automations/dataEvents': typeof AuthOOrgIdAutomationsDataEventsRoute
  '/o/$orgId/automations/scheduled': typeof AuthOOrgIdAutomationsScheduledRoute
  '/o/$orgId/commentaryBox/$commentaryBoxId': typeof AuthOOrgIdCommentaryBoxCommentaryBoxIdRoute
  '/o/$orgId/encodingPresets/$encodingPresetId': typeof AuthOOrgIdEncodingPresetsEncodingPresetIdRoute
  '/o/$orgId/encodingPresets/new': typeof AuthOOrgIdEncodingPresetsNewRoute
  '/o/$orgId/liveInputs/$liveInputId': typeof AuthOOrgIdLiveInputsLiveInputIdRoute
  '/o/$orgId/liveOutputs/$liveOutputId': typeof AuthOOrgIdLiveOutputsLiveOutputIdRoute
  '/o/$orgId/usage/distributions': typeof AuthOOrgIdUsageDistributionsRoute
  '/o/$orgId/usage/overview': typeof AuthOOrgIdUsageOverviewRoute
  '/o/$orgId/usage/sessions': typeof AuthOOrgIdUsageSessionsRoute
  '/orgs/$orgId/apiKeys/$name': typeof AuthOrgsOrgIdApiKeysNameRoute
  '/staff/o/$orgId/features': typeof AuthStaffOOrgIdFeaturesRoute
  '/staff/o/$orgId/members': typeof AuthStaffOOrgIdMembersRoute
  '/o/$orgId/automations/': typeof AuthOOrgIdAutomationsIndexRoute
  '/o/$orgId/commentaryBox/': typeof AuthOOrgIdCommentaryBoxIndexRoute
  '/o/$orgId/encodingPresets/': typeof AuthOOrgIdEncodingPresetsIndexRoute
  '/o/$orgId/liveInputs/': typeof AuthOOrgIdLiveInputsIndexRoute
  '/o/$orgId/liveOutputs/': typeof AuthOOrgIdLiveOutputsIndexRoute
  '/o/$orgId/mediaLibrary/': typeof AuthOOrgIdMediaLibraryIndexRoute
  '/o/$orgId/multiview/': typeof AuthOOrgIdMultiviewIndexRoute
  '/o/$orgId/projects/': typeof AuthOOrgIdProjectsIndexRoute
  '/o/$orgId/sessions/': typeof AuthOOrgIdSessionsIndexRoute
  '/orgs/$orgId/apiKeys/': typeof AuthOrgsOrgIdApiKeysIndexRoute
  '/o/$orgId/projects/$projectId/$workflowSessionId': typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteWithChildren
  '/o/$orgId/projects/$projectId/manage': typeof AuthOOrgIdProjectsProjectIdManageRouteRouteWithChildren
  '/o/$orgId/projects/$projectId/s': typeof AuthOOrgIdProjectsProjectIdSRouteRouteWithChildren
  '/o/$orgId/projects/$projectId/$workflowSessionId/control': typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdControlRoute
  '/o/$orgId/projects/$projectId/$workflowSessionId/monitor': typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdMonitorRoute
  '/o/$orgId/projects/$projectId/$workflowSessionId/workflow': typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdWorkflowRoute
  '/o/$orgId/projects/$projectId/manage/components': typeof AuthOOrgIdProjectsProjectIdManageComponentsRoute
  '/o/$orgId/projects/$projectId/manage/': typeof AuthOOrgIdProjectsProjectIdManageIndexRoute
  '/o/$orgId/projects/$projectId/s/': typeof AuthOOrgIdProjectsProjectIdSIndexRoute
  '/o/$orgId/projects/$projectId/workflow': typeof AuthOOrgIdProjectsProjectIdWorkflowIndexRoute
  '/o/$orgId/projects/$projectId/s/$workflowSessionId/r': typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRouteWithChildren
  '/o/$orgId/projects/$projectId/s/$workflowSessionId': typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdIndexRoute
  '/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId': typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRecordingIdRoute
  '/o/$orgId/projects/$projectId/s/$workflowSessionId/r/': typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgotPassword': typeof ForgotPasswordRoute
  '/resetPassword': typeof ResetPasswordRoute
  '/signin': typeof SigninRoute
  '/staff': typeof AuthStaffRouteRouteWithChildren
  '/staff/forgotPassword': typeof StaffForgotPasswordRoute
  '/staff/signin': typeof StaffSigninRoute
  '/orgs/$orgId': typeof AuthOrgsOrgIdRouteRouteWithChildren
  '/staff/engines': typeof AuthStaffEnginesRoute
  '/staff/sessions': typeof AuthStaffSessionsRoute
  '/lobby/$projectId/$token': typeof LobbyProjectIdTokenRoute
  '/o': typeof AuthOIndexRoute
  '/orgs': typeof AuthOrgsIndexRoute
  '/settings': typeof AuthSettingsIndexRoute
  '/orgs/$orgId/members': typeof AuthOrgsOrgIdMembersRoute
  '/staff/u/$userId': typeof AuthStaffUUserIdRoute
  '/o/$orgId': typeof AuthOOrgIdIndexRoute
  '/staff/o': typeof AuthStaffOIndexRoute
  '/staff/u': typeof AuthStaffUIndexRoute
  '/o/$orgId/automations/dataEvents': typeof AuthOOrgIdAutomationsDataEventsRoute
  '/o/$orgId/automations/scheduled': typeof AuthOOrgIdAutomationsScheduledRoute
  '/o/$orgId/commentaryBox/$commentaryBoxId': typeof AuthOOrgIdCommentaryBoxCommentaryBoxIdRoute
  '/o/$orgId/encodingPresets/$encodingPresetId': typeof AuthOOrgIdEncodingPresetsEncodingPresetIdRoute
  '/o/$orgId/encodingPresets/new': typeof AuthOOrgIdEncodingPresetsNewRoute
  '/o/$orgId/liveInputs/$liveInputId': typeof AuthOOrgIdLiveInputsLiveInputIdRoute
  '/o/$orgId/liveOutputs/$liveOutputId': typeof AuthOOrgIdLiveOutputsLiveOutputIdRoute
  '/o/$orgId/usage/distributions': typeof AuthOOrgIdUsageDistributionsRoute
  '/o/$orgId/usage/overview': typeof AuthOOrgIdUsageOverviewRoute
  '/o/$orgId/usage/sessions': typeof AuthOOrgIdUsageSessionsRoute
  '/orgs/$orgId/apiKeys/$name': typeof AuthOrgsOrgIdApiKeysNameRoute
  '/staff/o/$orgId/features': typeof AuthStaffOOrgIdFeaturesRoute
  '/staff/o/$orgId/members': typeof AuthStaffOOrgIdMembersRoute
  '/o/$orgId/automations': typeof AuthOOrgIdAutomationsIndexRoute
  '/o/$orgId/commentaryBox': typeof AuthOOrgIdCommentaryBoxIndexRoute
  '/o/$orgId/encodingPresets': typeof AuthOOrgIdEncodingPresetsIndexRoute
  '/o/$orgId/liveInputs': typeof AuthOOrgIdLiveInputsIndexRoute
  '/o/$orgId/liveOutputs': typeof AuthOOrgIdLiveOutputsIndexRoute
  '/o/$orgId/mediaLibrary': typeof AuthOOrgIdMediaLibraryIndexRoute
  '/o/$orgId/multiview': typeof AuthOOrgIdMultiviewIndexRoute
  '/o/$orgId/projects': typeof AuthOOrgIdProjectsIndexRoute
  '/o/$orgId/sessions': typeof AuthOOrgIdSessionsIndexRoute
  '/orgs/$orgId/apiKeys': typeof AuthOrgsOrgIdApiKeysIndexRoute
  '/o/$orgId/projects/$projectId/$workflowSessionId': typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteWithChildren
  '/o/$orgId/projects/$projectId/$workflowSessionId/control': typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdControlRoute
  '/o/$orgId/projects/$projectId/$workflowSessionId/monitor': typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdMonitorRoute
  '/o/$orgId/projects/$projectId/$workflowSessionId/workflow': typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdWorkflowRoute
  '/o/$orgId/projects/$projectId/manage/components': typeof AuthOOrgIdProjectsProjectIdManageComponentsRoute
  '/o/$orgId/projects/$projectId/manage': typeof AuthOOrgIdProjectsProjectIdManageIndexRoute
  '/o/$orgId/projects/$projectId/s': typeof AuthOOrgIdProjectsProjectIdSIndexRoute
  '/o/$orgId/projects/$projectId/workflow': typeof AuthOOrgIdProjectsProjectIdWorkflowIndexRoute
  '/o/$orgId/projects/$projectId/s/$workflowSessionId': typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdIndexRoute
  '/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId': typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRecordingIdRoute
  '/o/$orgId/projects/$projectId/s/$workflowSessionId/r': typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/forgotPassword': typeof ForgotPasswordRoute
  '/resetPassword': typeof ResetPasswordRoute
  '/signin': typeof SigninRoute
  '/_auth/orgs': typeof AuthOrgsRouteRouteWithChildren
  '/_auth/staff': typeof AuthStaffRouteRouteWithChildren
  '/staff_/forgotPassword': typeof StaffForgotPasswordRoute
  '/staff_/signin': typeof StaffSigninRoute
  '/_auth/o/$orgId': typeof AuthOOrgIdRouteRouteWithChildren
  '/_auth/orgs/$orgId': typeof AuthOrgsOrgIdRouteRouteWithChildren
  '/_auth/staff/o': typeof AuthStaffORouteRouteWithChildren
  '/_auth/staff/u': typeof AuthStaffURouteRouteWithChildren
  '/_auth/staff/engines': typeof AuthStaffEnginesRoute
  '/_auth/staff/sessions': typeof AuthStaffSessionsRoute
  '/lobby/$projectId/$token': typeof LobbyProjectIdTokenRoute
  '/_auth/o/': typeof AuthOIndexRoute
  '/_auth/orgs/': typeof AuthOrgsIndexRoute
  '/_auth/settings/': typeof AuthSettingsIndexRoute
  '/_auth/o/$orgId/automations': typeof AuthOOrgIdAutomationsRouteRouteWithChildren
  '/_auth/o/$orgId/commentaryBox': typeof AuthOOrgIdCommentaryBoxRouteRouteWithChildren
  '/_auth/o/$orgId/encodingPresets': typeof AuthOOrgIdEncodingPresetsRouteRouteWithChildren
  '/_auth/o/$orgId/liveInputs': typeof AuthOOrgIdLiveInputsRouteRouteWithChildren
  '/_auth/o/$orgId/liveOutputs': typeof AuthOOrgIdLiveOutputsRouteRouteWithChildren
  '/_auth/o/$orgId/mediaLibrary': typeof AuthOOrgIdMediaLibraryRouteRouteWithChildren
  '/_auth/o/$orgId/multiview': typeof AuthOOrgIdMultiviewRouteRouteWithChildren
  '/_auth/o/$orgId/projects': typeof AuthOOrgIdProjectsRouteRouteWithChildren
  '/_auth/o/$orgId/sessions': typeof AuthOOrgIdSessionsRouteRouteWithChildren
  '/_auth/orgs/$orgId/apiKeys': typeof AuthOrgsOrgIdApiKeysRouteRouteWithChildren
  '/_auth/orgs/$orgId/members': typeof AuthOrgsOrgIdMembersRoute
  '/_auth/staff/u/$userId': typeof AuthStaffUUserIdRoute
  '/_auth/o/$orgId/': typeof AuthOOrgIdIndexRoute
  '/_auth/staff/o/': typeof AuthStaffOIndexRoute
  '/_auth/staff/u/': typeof AuthStaffUIndexRoute
  '/_auth/o/$orgId/automations/dataEvents': typeof AuthOOrgIdAutomationsDataEventsRoute
  '/_auth/o/$orgId/automations/scheduled': typeof AuthOOrgIdAutomationsScheduledRoute
  '/_auth/o/$orgId/commentaryBox/$commentaryBoxId': typeof AuthOOrgIdCommentaryBoxCommentaryBoxIdRoute
  '/_auth/o/$orgId/encodingPresets/$encodingPresetId': typeof AuthOOrgIdEncodingPresetsEncodingPresetIdRoute
  '/_auth/o/$orgId/encodingPresets/new': typeof AuthOOrgIdEncodingPresetsNewRoute
  '/_auth/o/$orgId/liveInputs/$liveInputId': typeof AuthOOrgIdLiveInputsLiveInputIdRoute
  '/_auth/o/$orgId/liveOutputs/$liveOutputId': typeof AuthOOrgIdLiveOutputsLiveOutputIdRoute
  '/_auth/o/$orgId/usage/distributions': typeof AuthOOrgIdUsageDistributionsRoute
  '/_auth/o/$orgId/usage/overview': typeof AuthOOrgIdUsageOverviewRoute
  '/_auth/o/$orgId/usage/sessions': typeof AuthOOrgIdUsageSessionsRoute
  '/_auth/orgs/$orgId/apiKeys/$name': typeof AuthOrgsOrgIdApiKeysNameRoute
  '/_auth/staff/o/$orgId/features': typeof AuthStaffOOrgIdFeaturesRoute
  '/_auth/staff/o/$orgId/members': typeof AuthStaffOOrgIdMembersRoute
  '/_auth/o/$orgId/automations/': typeof AuthOOrgIdAutomationsIndexRoute
  '/_auth/o/$orgId/commentaryBox/': typeof AuthOOrgIdCommentaryBoxIndexRoute
  '/_auth/o/$orgId/encodingPresets/': typeof AuthOOrgIdEncodingPresetsIndexRoute
  '/_auth/o/$orgId/liveInputs/': typeof AuthOOrgIdLiveInputsIndexRoute
  '/_auth/o/$orgId/liveOutputs/': typeof AuthOOrgIdLiveOutputsIndexRoute
  '/_auth/o/$orgId/mediaLibrary/': typeof AuthOOrgIdMediaLibraryIndexRoute
  '/_auth/o/$orgId/multiview/': typeof AuthOOrgIdMultiviewIndexRoute
  '/_auth/o/$orgId/projects/': typeof AuthOOrgIdProjectsIndexRoute
  '/_auth/o/$orgId/sessions/': typeof AuthOOrgIdSessionsIndexRoute
  '/_auth/orgs/$orgId/apiKeys/': typeof AuthOrgsOrgIdApiKeysIndexRoute
  '/_auth/o/$orgId/projects/$projectId/$workflowSessionId': typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteWithChildren
  '/_auth/o/$orgId/projects/$projectId/manage': typeof AuthOOrgIdProjectsProjectIdManageRouteRouteWithChildren
  '/_auth/o/$orgId/projects/$projectId/s': typeof AuthOOrgIdProjectsProjectIdSRouteRouteWithChildren
  '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/control': typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdControlRoute
  '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/monitor': typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdMonitorRoute
  '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/workflow': typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdWorkflowRoute
  '/_auth/o/$orgId/projects/$projectId/manage/components': typeof AuthOOrgIdProjectsProjectIdManageComponentsRoute
  '/_auth/o/$orgId/projects/$projectId/manage/': typeof AuthOOrgIdProjectsProjectIdManageIndexRoute
  '/_auth/o/$orgId/projects/$projectId/s/': typeof AuthOOrgIdProjectsProjectIdSIndexRoute
  '/_auth/o/$orgId/projects/$projectId/workflow/': typeof AuthOOrgIdProjectsProjectIdWorkflowIndexRoute
  '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r': typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRouteWithChildren
  '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/': typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdIndexRoute
  '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId': typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRecordingIdRoute
  '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/': typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgotPassword'
    | '/resetPassword'
    | '/signin'
    | '/orgs'
    | '/staff'
    | '/staff/forgotPassword'
    | '/staff/signin'
    | '/o/$orgId'
    | '/orgs/$orgId'
    | '/staff/o'
    | '/staff/u'
    | '/staff/engines'
    | '/staff/sessions'
    | '/lobby/$projectId/$token'
    | '/o'
    | '/orgs/'
    | '/settings'
    | '/o/$orgId/automations'
    | '/o/$orgId/commentaryBox'
    | '/o/$orgId/encodingPresets'
    | '/o/$orgId/liveInputs'
    | '/o/$orgId/liveOutputs'
    | '/o/$orgId/mediaLibrary'
    | '/o/$orgId/multiview'
    | '/o/$orgId/projects'
    | '/o/$orgId/sessions'
    | '/orgs/$orgId/apiKeys'
    | '/orgs/$orgId/members'
    | '/staff/u/$userId'
    | '/o/$orgId/'
    | '/staff/o/'
    | '/staff/u/'
    | '/o/$orgId/automations/dataEvents'
    | '/o/$orgId/automations/scheduled'
    | '/o/$orgId/commentaryBox/$commentaryBoxId'
    | '/o/$orgId/encodingPresets/$encodingPresetId'
    | '/o/$orgId/encodingPresets/new'
    | '/o/$orgId/liveInputs/$liveInputId'
    | '/o/$orgId/liveOutputs/$liveOutputId'
    | '/o/$orgId/usage/distributions'
    | '/o/$orgId/usage/overview'
    | '/o/$orgId/usage/sessions'
    | '/orgs/$orgId/apiKeys/$name'
    | '/staff/o/$orgId/features'
    | '/staff/o/$orgId/members'
    | '/o/$orgId/automations/'
    | '/o/$orgId/commentaryBox/'
    | '/o/$orgId/encodingPresets/'
    | '/o/$orgId/liveInputs/'
    | '/o/$orgId/liveOutputs/'
    | '/o/$orgId/mediaLibrary/'
    | '/o/$orgId/multiview/'
    | '/o/$orgId/projects/'
    | '/o/$orgId/sessions/'
    | '/orgs/$orgId/apiKeys/'
    | '/o/$orgId/projects/$projectId/$workflowSessionId'
    | '/o/$orgId/projects/$projectId/manage'
    | '/o/$orgId/projects/$projectId/s'
    | '/o/$orgId/projects/$projectId/$workflowSessionId/control'
    | '/o/$orgId/projects/$projectId/$workflowSessionId/monitor'
    | '/o/$orgId/projects/$projectId/$workflowSessionId/workflow'
    | '/o/$orgId/projects/$projectId/manage/components'
    | '/o/$orgId/projects/$projectId/manage/'
    | '/o/$orgId/projects/$projectId/s/'
    | '/o/$orgId/projects/$projectId/workflow'
    | '/o/$orgId/projects/$projectId/s/$workflowSessionId/r'
    | '/o/$orgId/projects/$projectId/s/$workflowSessionId'
    | '/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId'
    | '/o/$orgId/projects/$projectId/s/$workflowSessionId/r/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgotPassword'
    | '/resetPassword'
    | '/signin'
    | '/staff'
    | '/staff/forgotPassword'
    | '/staff/signin'
    | '/orgs/$orgId'
    | '/staff/engines'
    | '/staff/sessions'
    | '/lobby/$projectId/$token'
    | '/o'
    | '/orgs'
    | '/settings'
    | '/orgs/$orgId/members'
    | '/staff/u/$userId'
    | '/o/$orgId'
    | '/staff/o'
    | '/staff/u'
    | '/o/$orgId/automations/dataEvents'
    | '/o/$orgId/automations/scheduled'
    | '/o/$orgId/commentaryBox/$commentaryBoxId'
    | '/o/$orgId/encodingPresets/$encodingPresetId'
    | '/o/$orgId/encodingPresets/new'
    | '/o/$orgId/liveInputs/$liveInputId'
    | '/o/$orgId/liveOutputs/$liveOutputId'
    | '/o/$orgId/usage/distributions'
    | '/o/$orgId/usage/overview'
    | '/o/$orgId/usage/sessions'
    | '/orgs/$orgId/apiKeys/$name'
    | '/staff/o/$orgId/features'
    | '/staff/o/$orgId/members'
    | '/o/$orgId/automations'
    | '/o/$orgId/commentaryBox'
    | '/o/$orgId/encodingPresets'
    | '/o/$orgId/liveInputs'
    | '/o/$orgId/liveOutputs'
    | '/o/$orgId/mediaLibrary'
    | '/o/$orgId/multiview'
    | '/o/$orgId/projects'
    | '/o/$orgId/sessions'
    | '/orgs/$orgId/apiKeys'
    | '/o/$orgId/projects/$projectId/$workflowSessionId'
    | '/o/$orgId/projects/$projectId/$workflowSessionId/control'
    | '/o/$orgId/projects/$projectId/$workflowSessionId/monitor'
    | '/o/$orgId/projects/$projectId/$workflowSessionId/workflow'
    | '/o/$orgId/projects/$projectId/manage/components'
    | '/o/$orgId/projects/$projectId/manage'
    | '/o/$orgId/projects/$projectId/s'
    | '/o/$orgId/projects/$projectId/workflow'
    | '/o/$orgId/projects/$projectId/s/$workflowSessionId'
    | '/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId'
    | '/o/$orgId/projects/$projectId/s/$workflowSessionId/r'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/forgotPassword'
    | '/resetPassword'
    | '/signin'
    | '/_auth/orgs'
    | '/_auth/staff'
    | '/staff_/forgotPassword'
    | '/staff_/signin'
    | '/_auth/o/$orgId'
    | '/_auth/orgs/$orgId'
    | '/_auth/staff/o'
    | '/_auth/staff/u'
    | '/_auth/staff/engines'
    | '/_auth/staff/sessions'
    | '/lobby/$projectId/$token'
    | '/_auth/o/'
    | '/_auth/orgs/'
    | '/_auth/settings/'
    | '/_auth/o/$orgId/automations'
    | '/_auth/o/$orgId/commentaryBox'
    | '/_auth/o/$orgId/encodingPresets'
    | '/_auth/o/$orgId/liveInputs'
    | '/_auth/o/$orgId/liveOutputs'
    | '/_auth/o/$orgId/mediaLibrary'
    | '/_auth/o/$orgId/multiview'
    | '/_auth/o/$orgId/projects'
    | '/_auth/o/$orgId/sessions'
    | '/_auth/orgs/$orgId/apiKeys'
    | '/_auth/orgs/$orgId/members'
    | '/_auth/staff/u/$userId'
    | '/_auth/o/$orgId/'
    | '/_auth/staff/o/'
    | '/_auth/staff/u/'
    | '/_auth/o/$orgId/automations/dataEvents'
    | '/_auth/o/$orgId/automations/scheduled'
    | '/_auth/o/$orgId/commentaryBox/$commentaryBoxId'
    | '/_auth/o/$orgId/encodingPresets/$encodingPresetId'
    | '/_auth/o/$orgId/encodingPresets/new'
    | '/_auth/o/$orgId/liveInputs/$liveInputId'
    | '/_auth/o/$orgId/liveOutputs/$liveOutputId'
    | '/_auth/o/$orgId/usage/distributions'
    | '/_auth/o/$orgId/usage/overview'
    | '/_auth/o/$orgId/usage/sessions'
    | '/_auth/orgs/$orgId/apiKeys/$name'
    | '/_auth/staff/o/$orgId/features'
    | '/_auth/staff/o/$orgId/members'
    | '/_auth/o/$orgId/automations/'
    | '/_auth/o/$orgId/commentaryBox/'
    | '/_auth/o/$orgId/encodingPresets/'
    | '/_auth/o/$orgId/liveInputs/'
    | '/_auth/o/$orgId/liveOutputs/'
    | '/_auth/o/$orgId/mediaLibrary/'
    | '/_auth/o/$orgId/multiview/'
    | '/_auth/o/$orgId/projects/'
    | '/_auth/o/$orgId/sessions/'
    | '/_auth/orgs/$orgId/apiKeys/'
    | '/_auth/o/$orgId/projects/$projectId/$workflowSessionId'
    | '/_auth/o/$orgId/projects/$projectId/manage'
    | '/_auth/o/$orgId/projects/$projectId/s'
    | '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/control'
    | '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/monitor'
    | '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/workflow'
    | '/_auth/o/$orgId/projects/$projectId/manage/components'
    | '/_auth/o/$orgId/projects/$projectId/manage/'
    | '/_auth/o/$orgId/projects/$projectId/s/'
    | '/_auth/o/$orgId/projects/$projectId/workflow/'
    | '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r'
    | '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/'
    | '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId'
    | '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SigninRoute: typeof SigninRoute
  StaffForgotPasswordRoute: typeof StaffForgotPasswordRoute
  StaffSigninRoute: typeof StaffSigninRoute
  LobbyProjectIdTokenRoute: typeof LobbyProjectIdTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resetPassword': {
      id: '/resetPassword'
      path: '/resetPassword'
      fullPath: '/resetPassword'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgotPassword': {
      id: '/forgotPassword'
      path: '/forgotPassword'
      fullPath: '/forgotPassword'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff_/signin': {
      id: '/staff_/signin'
      path: '/staff/signin'
      fullPath: '/staff/signin'
      preLoaderRoute: typeof StaffSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff_/forgotPassword': {
      id: '/staff_/forgotPassword'
      path: '/staff/forgotPassword'
      fullPath: '/staff/forgotPassword'
      preLoaderRoute: typeof StaffForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/staff': {
      id: '/_auth/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AuthStaffRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/orgs': {
      id: '/_auth/orgs'
      path: '/orgs'
      fullPath: '/orgs'
      preLoaderRoute: typeof AuthOrgsRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/settings/': {
      id: '/_auth/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/orgs/': {
      id: '/_auth/orgs/'
      path: '/'
      fullPath: '/orgs/'
      preLoaderRoute: typeof AuthOrgsIndexRouteImport
      parentRoute: typeof AuthOrgsRouteRoute
    }
    '/_auth/o/': {
      id: '/_auth/o/'
      path: '/o'
      fullPath: '/o'
      preLoaderRoute: typeof AuthOIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/lobby/$projectId/$token': {
      id: '/lobby/$projectId/$token'
      path: '/lobby/$projectId/$token'
      fullPath: '/lobby/$projectId/$token'
      preLoaderRoute: typeof LobbyProjectIdTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/staff/sessions': {
      id: '/_auth/staff/sessions'
      path: '/sessions'
      fullPath: '/staff/sessions'
      preLoaderRoute: typeof AuthStaffSessionsRouteImport
      parentRoute: typeof AuthStaffRouteRoute
    }
    '/_auth/staff/engines': {
      id: '/_auth/staff/engines'
      path: '/engines'
      fullPath: '/staff/engines'
      preLoaderRoute: typeof AuthStaffEnginesRouteImport
      parentRoute: typeof AuthStaffRouteRoute
    }
    '/_auth/staff/u': {
      id: '/_auth/staff/u'
      path: '/u'
      fullPath: '/staff/u'
      preLoaderRoute: typeof AuthStaffURouteRouteImport
      parentRoute: typeof AuthStaffRouteRoute
    }
    '/_auth/staff/o': {
      id: '/_auth/staff/o'
      path: '/o'
      fullPath: '/staff/o'
      preLoaderRoute: typeof AuthStaffORouteRouteImport
      parentRoute: typeof AuthStaffRouteRoute
    }
    '/_auth/orgs/$orgId': {
      id: '/_auth/orgs/$orgId'
      path: '/$orgId'
      fullPath: '/orgs/$orgId'
      preLoaderRoute: typeof AuthOrgsOrgIdRouteRouteImport
      parentRoute: typeof AuthOrgsRouteRoute
    }
    '/_auth/o/$orgId': {
      id: '/_auth/o/$orgId'
      path: '/o/$orgId'
      fullPath: '/o/$orgId'
      preLoaderRoute: typeof AuthOOrgIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/staff/u/': {
      id: '/_auth/staff/u/'
      path: '/'
      fullPath: '/staff/u/'
      preLoaderRoute: typeof AuthStaffUIndexRouteImport
      parentRoute: typeof AuthStaffURouteRoute
    }
    '/_auth/staff/o/': {
      id: '/_auth/staff/o/'
      path: '/'
      fullPath: '/staff/o/'
      preLoaderRoute: typeof AuthStaffOIndexRouteImport
      parentRoute: typeof AuthStaffORouteRoute
    }
    '/_auth/o/$orgId/': {
      id: '/_auth/o/$orgId/'
      path: '/'
      fullPath: '/o/$orgId/'
      preLoaderRoute: typeof AuthOOrgIdIndexRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/staff/u/$userId': {
      id: '/_auth/staff/u/$userId'
      path: '/$userId'
      fullPath: '/staff/u/$userId'
      preLoaderRoute: typeof AuthStaffUUserIdRouteImport
      parentRoute: typeof AuthStaffURouteRoute
    }
    '/_auth/orgs/$orgId/members': {
      id: '/_auth/orgs/$orgId/members'
      path: '/members'
      fullPath: '/orgs/$orgId/members'
      preLoaderRoute: typeof AuthOrgsOrgIdMembersRouteImport
      parentRoute: typeof AuthOrgsOrgIdRouteRoute
    }
    '/_auth/orgs/$orgId/apiKeys': {
      id: '/_auth/orgs/$orgId/apiKeys'
      path: '/apiKeys'
      fullPath: '/orgs/$orgId/apiKeys'
      preLoaderRoute: typeof AuthOrgsOrgIdApiKeysRouteRouteImport
      parentRoute: typeof AuthOrgsOrgIdRouteRoute
    }
    '/_auth/o/$orgId/sessions': {
      id: '/_auth/o/$orgId/sessions'
      path: '/sessions'
      fullPath: '/o/$orgId/sessions'
      preLoaderRoute: typeof AuthOOrgIdSessionsRouteRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/o/$orgId/projects': {
      id: '/_auth/o/$orgId/projects'
      path: '/projects'
      fullPath: '/o/$orgId/projects'
      preLoaderRoute: typeof AuthOOrgIdProjectsRouteRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/o/$orgId/multiview': {
      id: '/_auth/o/$orgId/multiview'
      path: '/multiview'
      fullPath: '/o/$orgId/multiview'
      preLoaderRoute: typeof AuthOOrgIdMultiviewRouteRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/o/$orgId/mediaLibrary': {
      id: '/_auth/o/$orgId/mediaLibrary'
      path: '/mediaLibrary'
      fullPath: '/o/$orgId/mediaLibrary'
      preLoaderRoute: typeof AuthOOrgIdMediaLibraryRouteRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/o/$orgId/liveOutputs': {
      id: '/_auth/o/$orgId/liveOutputs'
      path: '/liveOutputs'
      fullPath: '/o/$orgId/liveOutputs'
      preLoaderRoute: typeof AuthOOrgIdLiveOutputsRouteRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/o/$orgId/liveInputs': {
      id: '/_auth/o/$orgId/liveInputs'
      path: '/liveInputs'
      fullPath: '/o/$orgId/liveInputs'
      preLoaderRoute: typeof AuthOOrgIdLiveInputsRouteRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/o/$orgId/encodingPresets': {
      id: '/_auth/o/$orgId/encodingPresets'
      path: '/encodingPresets'
      fullPath: '/o/$orgId/encodingPresets'
      preLoaderRoute: typeof AuthOOrgIdEncodingPresetsRouteRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/o/$orgId/commentaryBox': {
      id: '/_auth/o/$orgId/commentaryBox'
      path: '/commentaryBox'
      fullPath: '/o/$orgId/commentaryBox'
      preLoaderRoute: typeof AuthOOrgIdCommentaryBoxRouteRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/o/$orgId/automations': {
      id: '/_auth/o/$orgId/automations'
      path: '/automations'
      fullPath: '/o/$orgId/automations'
      preLoaderRoute: typeof AuthOOrgIdAutomationsRouteRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/orgs/$orgId/apiKeys/': {
      id: '/_auth/orgs/$orgId/apiKeys/'
      path: '/'
      fullPath: '/orgs/$orgId/apiKeys/'
      preLoaderRoute: typeof AuthOrgsOrgIdApiKeysIndexRouteImport
      parentRoute: typeof AuthOrgsOrgIdApiKeysRouteRoute
    }
    '/_auth/o/$orgId/sessions/': {
      id: '/_auth/o/$orgId/sessions/'
      path: '/'
      fullPath: '/o/$orgId/sessions/'
      preLoaderRoute: typeof AuthOOrgIdSessionsIndexRouteImport
      parentRoute: typeof AuthOOrgIdSessionsRouteRoute
    }
    '/_auth/o/$orgId/projects/': {
      id: '/_auth/o/$orgId/projects/'
      path: '/'
      fullPath: '/o/$orgId/projects/'
      preLoaderRoute: typeof AuthOOrgIdProjectsIndexRouteImport
      parentRoute: typeof AuthOOrgIdProjectsRouteRoute
    }
    '/_auth/o/$orgId/multiview/': {
      id: '/_auth/o/$orgId/multiview/'
      path: '/'
      fullPath: '/o/$orgId/multiview/'
      preLoaderRoute: typeof AuthOOrgIdMultiviewIndexRouteImport
      parentRoute: typeof AuthOOrgIdMultiviewRouteRoute
    }
    '/_auth/o/$orgId/mediaLibrary/': {
      id: '/_auth/o/$orgId/mediaLibrary/'
      path: '/'
      fullPath: '/o/$orgId/mediaLibrary/'
      preLoaderRoute: typeof AuthOOrgIdMediaLibraryIndexRouteImport
      parentRoute: typeof AuthOOrgIdMediaLibraryRouteRoute
    }
    '/_auth/o/$orgId/liveOutputs/': {
      id: '/_auth/o/$orgId/liveOutputs/'
      path: '/'
      fullPath: '/o/$orgId/liveOutputs/'
      preLoaderRoute: typeof AuthOOrgIdLiveOutputsIndexRouteImport
      parentRoute: typeof AuthOOrgIdLiveOutputsRouteRoute
    }
    '/_auth/o/$orgId/liveInputs/': {
      id: '/_auth/o/$orgId/liveInputs/'
      path: '/'
      fullPath: '/o/$orgId/liveInputs/'
      preLoaderRoute: typeof AuthOOrgIdLiveInputsIndexRouteImport
      parentRoute: typeof AuthOOrgIdLiveInputsRouteRoute
    }
    '/_auth/o/$orgId/encodingPresets/': {
      id: '/_auth/o/$orgId/encodingPresets/'
      path: '/'
      fullPath: '/o/$orgId/encodingPresets/'
      preLoaderRoute: typeof AuthOOrgIdEncodingPresetsIndexRouteImport
      parentRoute: typeof AuthOOrgIdEncodingPresetsRouteRoute
    }
    '/_auth/o/$orgId/commentaryBox/': {
      id: '/_auth/o/$orgId/commentaryBox/'
      path: '/'
      fullPath: '/o/$orgId/commentaryBox/'
      preLoaderRoute: typeof AuthOOrgIdCommentaryBoxIndexRouteImport
      parentRoute: typeof AuthOOrgIdCommentaryBoxRouteRoute
    }
    '/_auth/o/$orgId/automations/': {
      id: '/_auth/o/$orgId/automations/'
      path: '/'
      fullPath: '/o/$orgId/automations/'
      preLoaderRoute: typeof AuthOOrgIdAutomationsIndexRouteImport
      parentRoute: typeof AuthOOrgIdAutomationsRouteRoute
    }
    '/_auth/staff/o/$orgId/members': {
      id: '/_auth/staff/o/$orgId/members'
      path: '/$orgId/members'
      fullPath: '/staff/o/$orgId/members'
      preLoaderRoute: typeof AuthStaffOOrgIdMembersRouteImport
      parentRoute: typeof AuthStaffORouteRoute
    }
    '/_auth/staff/o/$orgId/features': {
      id: '/_auth/staff/o/$orgId/features'
      path: '/$orgId/features'
      fullPath: '/staff/o/$orgId/features'
      preLoaderRoute: typeof AuthStaffOOrgIdFeaturesRouteImport
      parentRoute: typeof AuthStaffORouteRoute
    }
    '/_auth/orgs/$orgId/apiKeys/$name': {
      id: '/_auth/orgs/$orgId/apiKeys/$name'
      path: '/$name'
      fullPath: '/orgs/$orgId/apiKeys/$name'
      preLoaderRoute: typeof AuthOrgsOrgIdApiKeysNameRouteImport
      parentRoute: typeof AuthOrgsOrgIdApiKeysRouteRoute
    }
    '/_auth/o/$orgId/usage/sessions': {
      id: '/_auth/o/$orgId/usage/sessions'
      path: '/usage/sessions'
      fullPath: '/o/$orgId/usage/sessions'
      preLoaderRoute: typeof AuthOOrgIdUsageSessionsRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/o/$orgId/usage/overview': {
      id: '/_auth/o/$orgId/usage/overview'
      path: '/usage/overview'
      fullPath: '/o/$orgId/usage/overview'
      preLoaderRoute: typeof AuthOOrgIdUsageOverviewRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/o/$orgId/usage/distributions': {
      id: '/_auth/o/$orgId/usage/distributions'
      path: '/usage/distributions'
      fullPath: '/o/$orgId/usage/distributions'
      preLoaderRoute: typeof AuthOOrgIdUsageDistributionsRouteImport
      parentRoute: typeof AuthOOrgIdRouteRoute
    }
    '/_auth/o/$orgId/liveOutputs/$liveOutputId': {
      id: '/_auth/o/$orgId/liveOutputs/$liveOutputId'
      path: '/$liveOutputId'
      fullPath: '/o/$orgId/liveOutputs/$liveOutputId'
      preLoaderRoute: typeof AuthOOrgIdLiveOutputsLiveOutputIdRouteImport
      parentRoute: typeof AuthOOrgIdLiveOutputsRouteRoute
    }
    '/_auth/o/$orgId/liveInputs/$liveInputId': {
      id: '/_auth/o/$orgId/liveInputs/$liveInputId'
      path: '/$liveInputId'
      fullPath: '/o/$orgId/liveInputs/$liveInputId'
      preLoaderRoute: typeof AuthOOrgIdLiveInputsLiveInputIdRouteImport
      parentRoute: typeof AuthOOrgIdLiveInputsRouteRoute
    }
    '/_auth/o/$orgId/encodingPresets/new': {
      id: '/_auth/o/$orgId/encodingPresets/new'
      path: '/new'
      fullPath: '/o/$orgId/encodingPresets/new'
      preLoaderRoute: typeof AuthOOrgIdEncodingPresetsNewRouteImport
      parentRoute: typeof AuthOOrgIdEncodingPresetsRouteRoute
    }
    '/_auth/o/$orgId/encodingPresets/$encodingPresetId': {
      id: '/_auth/o/$orgId/encodingPresets/$encodingPresetId'
      path: '/$encodingPresetId'
      fullPath: '/o/$orgId/encodingPresets/$encodingPresetId'
      preLoaderRoute: typeof AuthOOrgIdEncodingPresetsEncodingPresetIdRouteImport
      parentRoute: typeof AuthOOrgIdEncodingPresetsRouteRoute
    }
    '/_auth/o/$orgId/commentaryBox/$commentaryBoxId': {
      id: '/_auth/o/$orgId/commentaryBox/$commentaryBoxId'
      path: '/$commentaryBoxId'
      fullPath: '/o/$orgId/commentaryBox/$commentaryBoxId'
      preLoaderRoute: typeof AuthOOrgIdCommentaryBoxCommentaryBoxIdRouteImport
      parentRoute: typeof AuthOOrgIdCommentaryBoxRouteRoute
    }
    '/_auth/o/$orgId/automations/scheduled': {
      id: '/_auth/o/$orgId/automations/scheduled'
      path: '/scheduled'
      fullPath: '/o/$orgId/automations/scheduled'
      preLoaderRoute: typeof AuthOOrgIdAutomationsScheduledRouteImport
      parentRoute: typeof AuthOOrgIdAutomationsRouteRoute
    }
    '/_auth/o/$orgId/automations/dataEvents': {
      id: '/_auth/o/$orgId/automations/dataEvents'
      path: '/dataEvents'
      fullPath: '/o/$orgId/automations/dataEvents'
      preLoaderRoute: typeof AuthOOrgIdAutomationsDataEventsRouteImport
      parentRoute: typeof AuthOOrgIdAutomationsRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/s': {
      id: '/_auth/o/$orgId/projects/$projectId/s'
      path: '/$projectId/s'
      fullPath: '/o/$orgId/projects/$projectId/s'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdSRouteRouteImport
      parentRoute: typeof AuthOOrgIdProjectsRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/manage': {
      id: '/_auth/o/$orgId/projects/$projectId/manage'
      path: '/$projectId/manage'
      fullPath: '/o/$orgId/projects/$projectId/manage'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdManageRouteRouteImport
      parentRoute: typeof AuthOOrgIdProjectsRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/$workflowSessionId': {
      id: '/_auth/o/$orgId/projects/$projectId/$workflowSessionId'
      path: '/$projectId/$workflowSessionId'
      fullPath: '/o/$orgId/projects/$projectId/$workflowSessionId'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteImport
      parentRoute: typeof AuthOOrgIdProjectsRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/workflow/': {
      id: '/_auth/o/$orgId/projects/$projectId/workflow/'
      path: '/$projectId/workflow'
      fullPath: '/o/$orgId/projects/$projectId/workflow'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowIndexRouteImport
      parentRoute: typeof AuthOOrgIdProjectsRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/s/': {
      id: '/_auth/o/$orgId/projects/$projectId/s/'
      path: '/'
      fullPath: '/o/$orgId/projects/$projectId/s/'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdSIndexRouteImport
      parentRoute: typeof AuthOOrgIdProjectsProjectIdSRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/manage/': {
      id: '/_auth/o/$orgId/projects/$projectId/manage/'
      path: '/'
      fullPath: '/o/$orgId/projects/$projectId/manage/'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdManageIndexRouteImport
      parentRoute: typeof AuthOOrgIdProjectsProjectIdManageRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/manage/components': {
      id: '/_auth/o/$orgId/projects/$projectId/manage/components'
      path: '/components'
      fullPath: '/o/$orgId/projects/$projectId/manage/components'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdManageComponentsRouteImport
      parentRoute: typeof AuthOOrgIdProjectsProjectIdManageRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/workflow': {
      id: '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/workflow'
      path: '/workflow'
      fullPath: '/o/$orgId/projects/$projectId/$workflowSessionId/workflow'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdWorkflowRouteImport
      parentRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/monitor': {
      id: '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/monitor'
      path: '/monitor'
      fullPath: '/o/$orgId/projects/$projectId/$workflowSessionId/monitor'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdMonitorRouteImport
      parentRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/control': {
      id: '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/control'
      path: '/control'
      fullPath: '/o/$orgId/projects/$projectId/$workflowSessionId/control'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdControlRouteImport
      parentRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/': {
      id: '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/'
      path: '/$workflowSessionId'
      fullPath: '/o/$orgId/projects/$projectId/s/$workflowSessionId'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdIndexRouteImport
      parentRoute: typeof AuthOOrgIdProjectsProjectIdSRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r': {
      id: '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r'
      path: '/$workflowSessionId/r'
      fullPath: '/o/$orgId/projects/$projectId/s/$workflowSessionId/r'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRouteImport
      parentRoute: typeof AuthOOrgIdProjectsProjectIdSRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/': {
      id: '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/'
      path: '/'
      fullPath: '/o/$orgId/projects/$projectId/s/$workflowSessionId/r/'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRIndexRouteImport
      parentRoute: typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRoute
    }
    '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId': {
      id: '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId'
      path: '/$recordingId'
      fullPath: '/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRecordingIdRouteImport
      parentRoute: typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRoute
    }
  }
}

interface AuthOrgsOrgIdApiKeysRouteRouteChildren {
  AuthOrgsOrgIdApiKeysNameRoute: typeof AuthOrgsOrgIdApiKeysNameRoute
  AuthOrgsOrgIdApiKeysIndexRoute: typeof AuthOrgsOrgIdApiKeysIndexRoute
}

const AuthOrgsOrgIdApiKeysRouteRouteChildren: AuthOrgsOrgIdApiKeysRouteRouteChildren =
  {
    AuthOrgsOrgIdApiKeysNameRoute: AuthOrgsOrgIdApiKeysNameRoute,
    AuthOrgsOrgIdApiKeysIndexRoute: AuthOrgsOrgIdApiKeysIndexRoute,
  }

const AuthOrgsOrgIdApiKeysRouteRouteWithChildren =
  AuthOrgsOrgIdApiKeysRouteRoute._addFileChildren(
    AuthOrgsOrgIdApiKeysRouteRouteChildren,
  )

interface AuthOrgsOrgIdRouteRouteChildren {
  AuthOrgsOrgIdApiKeysRouteRoute: typeof AuthOrgsOrgIdApiKeysRouteRouteWithChildren
  AuthOrgsOrgIdMembersRoute: typeof AuthOrgsOrgIdMembersRoute
}

const AuthOrgsOrgIdRouteRouteChildren: AuthOrgsOrgIdRouteRouteChildren = {
  AuthOrgsOrgIdApiKeysRouteRoute: AuthOrgsOrgIdApiKeysRouteRouteWithChildren,
  AuthOrgsOrgIdMembersRoute: AuthOrgsOrgIdMembersRoute,
}

const AuthOrgsOrgIdRouteRouteWithChildren =
  AuthOrgsOrgIdRouteRoute._addFileChildren(AuthOrgsOrgIdRouteRouteChildren)

interface AuthOrgsRouteRouteChildren {
  AuthOrgsOrgIdRouteRoute: typeof AuthOrgsOrgIdRouteRouteWithChildren
  AuthOrgsIndexRoute: typeof AuthOrgsIndexRoute
}

const AuthOrgsRouteRouteChildren: AuthOrgsRouteRouteChildren = {
  AuthOrgsOrgIdRouteRoute: AuthOrgsOrgIdRouteRouteWithChildren,
  AuthOrgsIndexRoute: AuthOrgsIndexRoute,
}

const AuthOrgsRouteRouteWithChildren = AuthOrgsRouteRoute._addFileChildren(
  AuthOrgsRouteRouteChildren,
)

interface AuthStaffORouteRouteChildren {
  AuthStaffOIndexRoute: typeof AuthStaffOIndexRoute
  AuthStaffOOrgIdFeaturesRoute: typeof AuthStaffOOrgIdFeaturesRoute
  AuthStaffOOrgIdMembersRoute: typeof AuthStaffOOrgIdMembersRoute
}

const AuthStaffORouteRouteChildren: AuthStaffORouteRouteChildren = {
  AuthStaffOIndexRoute: AuthStaffOIndexRoute,
  AuthStaffOOrgIdFeaturesRoute: AuthStaffOOrgIdFeaturesRoute,
  AuthStaffOOrgIdMembersRoute: AuthStaffOOrgIdMembersRoute,
}

const AuthStaffORouteRouteWithChildren = AuthStaffORouteRoute._addFileChildren(
  AuthStaffORouteRouteChildren,
)

interface AuthStaffURouteRouteChildren {
  AuthStaffUUserIdRoute: typeof AuthStaffUUserIdRoute
  AuthStaffUIndexRoute: typeof AuthStaffUIndexRoute
}

const AuthStaffURouteRouteChildren: AuthStaffURouteRouteChildren = {
  AuthStaffUUserIdRoute: AuthStaffUUserIdRoute,
  AuthStaffUIndexRoute: AuthStaffUIndexRoute,
}

const AuthStaffURouteRouteWithChildren = AuthStaffURouteRoute._addFileChildren(
  AuthStaffURouteRouteChildren,
)

interface AuthStaffRouteRouteChildren {
  AuthStaffORouteRoute: typeof AuthStaffORouteRouteWithChildren
  AuthStaffURouteRoute: typeof AuthStaffURouteRouteWithChildren
  AuthStaffEnginesRoute: typeof AuthStaffEnginesRoute
  AuthStaffSessionsRoute: typeof AuthStaffSessionsRoute
}

const AuthStaffRouteRouteChildren: AuthStaffRouteRouteChildren = {
  AuthStaffORouteRoute: AuthStaffORouteRouteWithChildren,
  AuthStaffURouteRoute: AuthStaffURouteRouteWithChildren,
  AuthStaffEnginesRoute: AuthStaffEnginesRoute,
  AuthStaffSessionsRoute: AuthStaffSessionsRoute,
}

const AuthStaffRouteRouteWithChildren = AuthStaffRouteRoute._addFileChildren(
  AuthStaffRouteRouteChildren,
)

interface AuthOOrgIdAutomationsRouteRouteChildren {
  AuthOOrgIdAutomationsDataEventsRoute: typeof AuthOOrgIdAutomationsDataEventsRoute
  AuthOOrgIdAutomationsScheduledRoute: typeof AuthOOrgIdAutomationsScheduledRoute
  AuthOOrgIdAutomationsIndexRoute: typeof AuthOOrgIdAutomationsIndexRoute
}

const AuthOOrgIdAutomationsRouteRouteChildren: AuthOOrgIdAutomationsRouteRouteChildren =
  {
    AuthOOrgIdAutomationsDataEventsRoute: AuthOOrgIdAutomationsDataEventsRoute,
    AuthOOrgIdAutomationsScheduledRoute: AuthOOrgIdAutomationsScheduledRoute,
    AuthOOrgIdAutomationsIndexRoute: AuthOOrgIdAutomationsIndexRoute,
  }

const AuthOOrgIdAutomationsRouteRouteWithChildren =
  AuthOOrgIdAutomationsRouteRoute._addFileChildren(
    AuthOOrgIdAutomationsRouteRouteChildren,
  )

interface AuthOOrgIdCommentaryBoxRouteRouteChildren {
  AuthOOrgIdCommentaryBoxCommentaryBoxIdRoute: typeof AuthOOrgIdCommentaryBoxCommentaryBoxIdRoute
  AuthOOrgIdCommentaryBoxIndexRoute: typeof AuthOOrgIdCommentaryBoxIndexRoute
}

const AuthOOrgIdCommentaryBoxRouteRouteChildren: AuthOOrgIdCommentaryBoxRouteRouteChildren =
  {
    AuthOOrgIdCommentaryBoxCommentaryBoxIdRoute:
      AuthOOrgIdCommentaryBoxCommentaryBoxIdRoute,
    AuthOOrgIdCommentaryBoxIndexRoute: AuthOOrgIdCommentaryBoxIndexRoute,
  }

const AuthOOrgIdCommentaryBoxRouteRouteWithChildren =
  AuthOOrgIdCommentaryBoxRouteRoute._addFileChildren(
    AuthOOrgIdCommentaryBoxRouteRouteChildren,
  )

interface AuthOOrgIdEncodingPresetsRouteRouteChildren {
  AuthOOrgIdEncodingPresetsEncodingPresetIdRoute: typeof AuthOOrgIdEncodingPresetsEncodingPresetIdRoute
  AuthOOrgIdEncodingPresetsNewRoute: typeof AuthOOrgIdEncodingPresetsNewRoute
  AuthOOrgIdEncodingPresetsIndexRoute: typeof AuthOOrgIdEncodingPresetsIndexRoute
}

const AuthOOrgIdEncodingPresetsRouteRouteChildren: AuthOOrgIdEncodingPresetsRouteRouteChildren =
  {
    AuthOOrgIdEncodingPresetsEncodingPresetIdRoute:
      AuthOOrgIdEncodingPresetsEncodingPresetIdRoute,
    AuthOOrgIdEncodingPresetsNewRoute: AuthOOrgIdEncodingPresetsNewRoute,
    AuthOOrgIdEncodingPresetsIndexRoute: AuthOOrgIdEncodingPresetsIndexRoute,
  }

const AuthOOrgIdEncodingPresetsRouteRouteWithChildren =
  AuthOOrgIdEncodingPresetsRouteRoute._addFileChildren(
    AuthOOrgIdEncodingPresetsRouteRouteChildren,
  )

interface AuthOOrgIdLiveInputsRouteRouteChildren {
  AuthOOrgIdLiveInputsLiveInputIdRoute: typeof AuthOOrgIdLiveInputsLiveInputIdRoute
  AuthOOrgIdLiveInputsIndexRoute: typeof AuthOOrgIdLiveInputsIndexRoute
}

const AuthOOrgIdLiveInputsRouteRouteChildren: AuthOOrgIdLiveInputsRouteRouteChildren =
  {
    AuthOOrgIdLiveInputsLiveInputIdRoute: AuthOOrgIdLiveInputsLiveInputIdRoute,
    AuthOOrgIdLiveInputsIndexRoute: AuthOOrgIdLiveInputsIndexRoute,
  }

const AuthOOrgIdLiveInputsRouteRouteWithChildren =
  AuthOOrgIdLiveInputsRouteRoute._addFileChildren(
    AuthOOrgIdLiveInputsRouteRouteChildren,
  )

interface AuthOOrgIdLiveOutputsRouteRouteChildren {
  AuthOOrgIdLiveOutputsLiveOutputIdRoute: typeof AuthOOrgIdLiveOutputsLiveOutputIdRoute
  AuthOOrgIdLiveOutputsIndexRoute: typeof AuthOOrgIdLiveOutputsIndexRoute
}

const AuthOOrgIdLiveOutputsRouteRouteChildren: AuthOOrgIdLiveOutputsRouteRouteChildren =
  {
    AuthOOrgIdLiveOutputsLiveOutputIdRoute:
      AuthOOrgIdLiveOutputsLiveOutputIdRoute,
    AuthOOrgIdLiveOutputsIndexRoute: AuthOOrgIdLiveOutputsIndexRoute,
  }

const AuthOOrgIdLiveOutputsRouteRouteWithChildren =
  AuthOOrgIdLiveOutputsRouteRoute._addFileChildren(
    AuthOOrgIdLiveOutputsRouteRouteChildren,
  )

interface AuthOOrgIdMediaLibraryRouteRouteChildren {
  AuthOOrgIdMediaLibraryIndexRoute: typeof AuthOOrgIdMediaLibraryIndexRoute
}

const AuthOOrgIdMediaLibraryRouteRouteChildren: AuthOOrgIdMediaLibraryRouteRouteChildren =
  {
    AuthOOrgIdMediaLibraryIndexRoute: AuthOOrgIdMediaLibraryIndexRoute,
  }

const AuthOOrgIdMediaLibraryRouteRouteWithChildren =
  AuthOOrgIdMediaLibraryRouteRoute._addFileChildren(
    AuthOOrgIdMediaLibraryRouteRouteChildren,
  )

interface AuthOOrgIdMultiviewRouteRouteChildren {
  AuthOOrgIdMultiviewIndexRoute: typeof AuthOOrgIdMultiviewIndexRoute
}

const AuthOOrgIdMultiviewRouteRouteChildren: AuthOOrgIdMultiviewRouteRouteChildren =
  {
    AuthOOrgIdMultiviewIndexRoute: AuthOOrgIdMultiviewIndexRoute,
  }

const AuthOOrgIdMultiviewRouteRouteWithChildren =
  AuthOOrgIdMultiviewRouteRoute._addFileChildren(
    AuthOOrgIdMultiviewRouteRouteChildren,
  )

interface AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteChildren {
  AuthOOrgIdProjectsProjectIdWorkflowSessionIdControlRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdControlRoute
  AuthOOrgIdProjectsProjectIdWorkflowSessionIdMonitorRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdMonitorRoute
  AuthOOrgIdProjectsProjectIdWorkflowSessionIdWorkflowRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdWorkflowRoute
}

const AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteChildren: AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteChildren =
  {
    AuthOOrgIdProjectsProjectIdWorkflowSessionIdControlRoute:
      AuthOOrgIdProjectsProjectIdWorkflowSessionIdControlRoute,
    AuthOOrgIdProjectsProjectIdWorkflowSessionIdMonitorRoute:
      AuthOOrgIdProjectsProjectIdWorkflowSessionIdMonitorRoute,
    AuthOOrgIdProjectsProjectIdWorkflowSessionIdWorkflowRoute:
      AuthOOrgIdProjectsProjectIdWorkflowSessionIdWorkflowRoute,
  }

const AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteWithChildren =
  AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRoute._addFileChildren(
    AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteChildren,
  )

interface AuthOOrgIdProjectsProjectIdManageRouteRouteChildren {
  AuthOOrgIdProjectsProjectIdManageComponentsRoute: typeof AuthOOrgIdProjectsProjectIdManageComponentsRoute
  AuthOOrgIdProjectsProjectIdManageIndexRoute: typeof AuthOOrgIdProjectsProjectIdManageIndexRoute
}

const AuthOOrgIdProjectsProjectIdManageRouteRouteChildren: AuthOOrgIdProjectsProjectIdManageRouteRouteChildren =
  {
    AuthOOrgIdProjectsProjectIdManageComponentsRoute:
      AuthOOrgIdProjectsProjectIdManageComponentsRoute,
    AuthOOrgIdProjectsProjectIdManageIndexRoute:
      AuthOOrgIdProjectsProjectIdManageIndexRoute,
  }

const AuthOOrgIdProjectsProjectIdManageRouteRouteWithChildren =
  AuthOOrgIdProjectsProjectIdManageRouteRoute._addFileChildren(
    AuthOOrgIdProjectsProjectIdManageRouteRouteChildren,
  )

interface AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRouteChildren {
  AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRecordingIdRoute: typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRecordingIdRoute
  AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRIndexRoute: typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRIndexRoute
}

const AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRouteChildren: AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRouteChildren =
  {
    AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRecordingIdRoute:
      AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRecordingIdRoute,
    AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRIndexRoute:
      AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRIndexRoute,
  }

const AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRouteWithChildren =
  AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRoute._addFileChildren(
    AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRouteChildren,
  )

interface AuthOOrgIdProjectsProjectIdSRouteRouteChildren {
  AuthOOrgIdProjectsProjectIdSIndexRoute: typeof AuthOOrgIdProjectsProjectIdSIndexRoute
  AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRoute: typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRouteWithChildren
  AuthOOrgIdProjectsProjectIdSWorkflowSessionIdIndexRoute: typeof AuthOOrgIdProjectsProjectIdSWorkflowSessionIdIndexRoute
}

const AuthOOrgIdProjectsProjectIdSRouteRouteChildren: AuthOOrgIdProjectsProjectIdSRouteRouteChildren =
  {
    AuthOOrgIdProjectsProjectIdSIndexRoute:
      AuthOOrgIdProjectsProjectIdSIndexRoute,
    AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRoute:
      AuthOOrgIdProjectsProjectIdSWorkflowSessionIdRRouteRouteWithChildren,
    AuthOOrgIdProjectsProjectIdSWorkflowSessionIdIndexRoute:
      AuthOOrgIdProjectsProjectIdSWorkflowSessionIdIndexRoute,
  }

const AuthOOrgIdProjectsProjectIdSRouteRouteWithChildren =
  AuthOOrgIdProjectsProjectIdSRouteRoute._addFileChildren(
    AuthOOrgIdProjectsProjectIdSRouteRouteChildren,
  )

interface AuthOOrgIdProjectsRouteRouteChildren {
  AuthOOrgIdProjectsIndexRoute: typeof AuthOOrgIdProjectsIndexRoute
  AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteWithChildren
  AuthOOrgIdProjectsProjectIdManageRouteRoute: typeof AuthOOrgIdProjectsProjectIdManageRouteRouteWithChildren
  AuthOOrgIdProjectsProjectIdSRouteRoute: typeof AuthOOrgIdProjectsProjectIdSRouteRouteWithChildren
  AuthOOrgIdProjectsProjectIdWorkflowIndexRoute: typeof AuthOOrgIdProjectsProjectIdWorkflowIndexRoute
}

const AuthOOrgIdProjectsRouteRouteChildren: AuthOOrgIdProjectsRouteRouteChildren =
  {
    AuthOOrgIdProjectsIndexRoute: AuthOOrgIdProjectsIndexRoute,
    AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRoute:
      AuthOOrgIdProjectsProjectIdWorkflowSessionIdRouteRouteWithChildren,
    AuthOOrgIdProjectsProjectIdManageRouteRoute:
      AuthOOrgIdProjectsProjectIdManageRouteRouteWithChildren,
    AuthOOrgIdProjectsProjectIdSRouteRoute:
      AuthOOrgIdProjectsProjectIdSRouteRouteWithChildren,
    AuthOOrgIdProjectsProjectIdWorkflowIndexRoute:
      AuthOOrgIdProjectsProjectIdWorkflowIndexRoute,
  }

const AuthOOrgIdProjectsRouteRouteWithChildren =
  AuthOOrgIdProjectsRouteRoute._addFileChildren(
    AuthOOrgIdProjectsRouteRouteChildren,
  )

interface AuthOOrgIdSessionsRouteRouteChildren {
  AuthOOrgIdSessionsIndexRoute: typeof AuthOOrgIdSessionsIndexRoute
}

const AuthOOrgIdSessionsRouteRouteChildren: AuthOOrgIdSessionsRouteRouteChildren =
  {
    AuthOOrgIdSessionsIndexRoute: AuthOOrgIdSessionsIndexRoute,
  }

const AuthOOrgIdSessionsRouteRouteWithChildren =
  AuthOOrgIdSessionsRouteRoute._addFileChildren(
    AuthOOrgIdSessionsRouteRouteChildren,
  )

interface AuthOOrgIdRouteRouteChildren {
  AuthOOrgIdAutomationsRouteRoute: typeof AuthOOrgIdAutomationsRouteRouteWithChildren
  AuthOOrgIdCommentaryBoxRouteRoute: typeof AuthOOrgIdCommentaryBoxRouteRouteWithChildren
  AuthOOrgIdEncodingPresetsRouteRoute: typeof AuthOOrgIdEncodingPresetsRouteRouteWithChildren
  AuthOOrgIdLiveInputsRouteRoute: typeof AuthOOrgIdLiveInputsRouteRouteWithChildren
  AuthOOrgIdLiveOutputsRouteRoute: typeof AuthOOrgIdLiveOutputsRouteRouteWithChildren
  AuthOOrgIdMediaLibraryRouteRoute: typeof AuthOOrgIdMediaLibraryRouteRouteWithChildren
  AuthOOrgIdMultiviewRouteRoute: typeof AuthOOrgIdMultiviewRouteRouteWithChildren
  AuthOOrgIdProjectsRouteRoute: typeof AuthOOrgIdProjectsRouteRouteWithChildren
  AuthOOrgIdSessionsRouteRoute: typeof AuthOOrgIdSessionsRouteRouteWithChildren
  AuthOOrgIdIndexRoute: typeof AuthOOrgIdIndexRoute
  AuthOOrgIdUsageDistributionsRoute: typeof AuthOOrgIdUsageDistributionsRoute
  AuthOOrgIdUsageOverviewRoute: typeof AuthOOrgIdUsageOverviewRoute
  AuthOOrgIdUsageSessionsRoute: typeof AuthOOrgIdUsageSessionsRoute
}

const AuthOOrgIdRouteRouteChildren: AuthOOrgIdRouteRouteChildren = {
  AuthOOrgIdAutomationsRouteRoute: AuthOOrgIdAutomationsRouteRouteWithChildren,
  AuthOOrgIdCommentaryBoxRouteRoute:
    AuthOOrgIdCommentaryBoxRouteRouteWithChildren,
  AuthOOrgIdEncodingPresetsRouteRoute:
    AuthOOrgIdEncodingPresetsRouteRouteWithChildren,
  AuthOOrgIdLiveInputsRouteRoute: AuthOOrgIdLiveInputsRouteRouteWithChildren,
  AuthOOrgIdLiveOutputsRouteRoute: AuthOOrgIdLiveOutputsRouteRouteWithChildren,
  AuthOOrgIdMediaLibraryRouteRoute:
    AuthOOrgIdMediaLibraryRouteRouteWithChildren,
  AuthOOrgIdMultiviewRouteRoute: AuthOOrgIdMultiviewRouteRouteWithChildren,
  AuthOOrgIdProjectsRouteRoute: AuthOOrgIdProjectsRouteRouteWithChildren,
  AuthOOrgIdSessionsRouteRoute: AuthOOrgIdSessionsRouteRouteWithChildren,
  AuthOOrgIdIndexRoute: AuthOOrgIdIndexRoute,
  AuthOOrgIdUsageDistributionsRoute: AuthOOrgIdUsageDistributionsRoute,
  AuthOOrgIdUsageOverviewRoute: AuthOOrgIdUsageOverviewRoute,
  AuthOOrgIdUsageSessionsRoute: AuthOOrgIdUsageSessionsRoute,
}

const AuthOOrgIdRouteRouteWithChildren = AuthOOrgIdRouteRoute._addFileChildren(
  AuthOOrgIdRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthOrgsRouteRoute: typeof AuthOrgsRouteRouteWithChildren
  AuthStaffRouteRoute: typeof AuthStaffRouteRouteWithChildren
  AuthOOrgIdRouteRoute: typeof AuthOOrgIdRouteRouteWithChildren
  AuthOIndexRoute: typeof AuthOIndexRoute
  AuthSettingsIndexRoute: typeof AuthSettingsIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthOrgsRouteRoute: AuthOrgsRouteRouteWithChildren,
  AuthStaffRouteRoute: AuthStaffRouteRouteWithChildren,
  AuthOOrgIdRouteRoute: AuthOOrgIdRouteRouteWithChildren,
  AuthOIndexRoute: AuthOIndexRoute,
  AuthSettingsIndexRoute: AuthSettingsIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SigninRoute: SigninRoute,
  StaffForgotPasswordRoute: StaffForgotPasswordRoute,
  StaffSigninRoute: StaffSigninRoute,
  LobbyProjectIdTokenRoute: LobbyProjectIdTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
